<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3205_57091)">
<rect y="10.3" width="7.02698" height="1.7" rx="0.85" fill="currentColor"/>
<rect x="14.973" y="10.3" width="7.02698" height="1.7" rx="0.85" fill="currentColor"/>
<rect x="8.08179" y="16.7604" width="12.8024" height="1.7" rx="0.85" transform="rotate(-70.6973 8.08179 16.7604)" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3205_57091">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
